import React from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { AUTO_COMPLETE_MAX_LIMIT } from "@/util/helper/webchatThemeHelper";
import { NumberInput, SwitchInput } from "@/component/input";

import { WebchatThemeFormProps } from ".";


const MessageBoxInputGroup: React.FC<WebchatThemeFormProps> = (props) => {
    const { theme, legend, onChange } = props;

    const intl = useIntl();

    return (
        <fieldset className="webchat-setting-card-grid">
            <legend className="sr-only">
                {legend}
            </legend>

            <div className="col-span-2 flex flex-col gap-1.5">
                <label htmlFor="webchat-setting-placeholder"
                       className="field-label"
                >
                    {intl.formatMessage({ id: "i09033" })}
                </label>
                <input type="text"
                       id="webchat-setting-placeholder"
                       className="input-default"
                       value={theme.chatInputPlaceholder}
                       placeholder={intl.formatMessage({ id: "i09034" })}
                       onChange={e => onChange({ ...theme, chatInputPlaceholder: e.target.value })}
                />
            </div>

            <label htmlFor="webchat-auto-complete"
                   className="label-input-grid-label field-label"
            >
                {intl.formatMessage({ id: "i09035" })}
            </label>
            <SwitchInput id="webchat-auto-complete"
                         defaultValue={theme.useAutoComplete}
                         onSwitch={value => {
                             onChange({ ...theme, useAutoComplete: value });
                         }}
            />
            <div className={classNames(
                     "webchat-setting-card-grid-indent",
                     "transition-disclosure",
                     theme.useAutoComplete ? "open" : "closed"
                 )}
            >
                <label htmlFor="webchat-setting-auto-complete-limit"
                       className="ml-2 label-input-grid-label input-label"
                >
                    {intl.formatMessage({ id: "i09089" })}
                </label>
                <NumberInput id="webchat-setting-auto-complete-limit"
                             width={96}
                             min={0}
                             max={AUTO_COMPLETE_MAX_LIMIT}
                             value={theme.autoCompleteLimit}
                             onChange={e => onChange({ ...theme, autoCompleteLimit: parseInt(e.target.value) })}
                />
            </div>
        </fieldset>
    );
};

export default MessageBoxInputGroup;
